@if (ready && !loading) {
  <div class="paze-express-checkout">
    <button type="button" class="paze-express-checkout__button" (click)="submit()" [disabled]="processing">
      @if (processing) {
        <span>{{ 'fgbcl.paze.processing' | translate: { fgbdefault: 'Processing…' } }}</span>
      } @else {
        <!-- Artwork depends on the mode: the "Add a card with paze" wordmark
             on the payment page, the plain provider mark when paying an
             order. See logoAsset. -->
        <img src="{{ logoAsset | contentAssetImage }}" alt="Paze" class="paze-express-checkout__logo" />
      }
    </button>
  </div>
}
